import { TilesError } from '@/plugins/tiles/TilesError'

export interface TextureSizing {
  readonly maxTextureSize: number
  readonly textureScale: number
}

export function resolveTextureSizing(options: Partial<TextureSizing> = {}): TextureSizing {
  const maxTextureSize = options.maxTextureSize ?? 1024
  const textureScale = options.textureScale ?? 1
  if (
    !Number.isSafeInteger(maxTextureSize) ||
    maxTextureSize < 1 ||
    !Number.isFinite(textureScale) ||
    textureScale <= 0 ||
    textureScale > 1
  ) {
    throw new TilesError({
      code: 'invalid-input',
      stage: 'decode',
      message: '纹理最大边长必须为正整数，缩放比例必须大于0且不超过1',
    })
  }
  return Object.freeze({ maxTextureSize, textureScale })
}

/** 同一缩放因子作用于两边，不拉伸、不放大小图，取整后每边至少1像素。 */
export function getTextureDimensions(
  image: { readonly width: number; readonly height: number },
  sizing: TextureSizing
): { width: number; height: number } {
  const scale = Math.min(
    sizing.textureScale,
    sizing.maxTextureSize / Math.max(image.width, image.height)
  )
  return {
    width: Math.max(1, Math.floor(image.width * scale)),
    height: Math.max(1, Math.floor(image.height * scale)),
  }
}
